export default "__VITE_ASSET__Dqioz0PS__"